<template>
  <div
    class="gallery"
    :class="{ 'gallery--thumbnail': displayType === 'thumbnail' }"
  >
    <WellsGallery
      v-if="type === 'wells'"
      :images="images"
      :thumbnail="thumbnail"
      :displayOtherImages="displayOtherImages"
      :canOpen="canOpen"
    ></WellsGallery>
  </div>
</template>

<style lang="scss" scoped>
.product__gallery {
  width: 30%;
}
</style>

<script>
import WellsGallery from "@/components/general-ui/galleries/Wells.vue";

export default {
  name: "Gallery",
  components: {
    WellsGallery
  },
  props: {
    displayType: {
      type: String,
      default() {
        return "gallery";
      }
    },
    canOpen: {
      type: Boolean,
      default() {
        return true;
      }
    },
    images: {
      type: Array,
      default() {
        return [];
      }
    },
    thumbnail: Object,
    displayOtherImages: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      type: ws_vue_store.config.galleries,
    };
  },
  methods: {}
};
</script>
